const styles = {
    messagesContainer: {
        height: "100%",
        width: "100%",
    }
};

export default styles;
